import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { Title } from '../layout';
import { TabsComponent } from '../common';
import { PublishedComponent } from './published';
import { ClosedComponent } from './closed';

export class DashboardMessagesComponent extends Component {

  render() {
    const { redirectTo } = this.props;

    const baseUrl = '/dashboard-messages'
    const routes = [
      {
        url: baseUrl,
        path: baseUrl,
        label: 'PUBLISHED',
        exact: true,
        component: PublishedComponent,
      },
      {
        url: baseUrl + '/closed',
        path: baseUrl + '/closed',
        label: 'CLOSED',
        component: ClosedComponent,
      }
    ];

    return (
      <div>
        <Title title="Notifications"/>
        <br/>
        <TabsComponent id={'message-types'} routes={routes}/>
        <br/>
        <button id="addButton" className='btn btn-primary' onClick={e => redirectTo('/add-message')}>
          Add Notification
        </button>
      </div>
    );
  }
}

DashboardMessagesComponent.propTypes = {
};

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardMessagesComponent);
